// ModernSlider.jsx
import { useState, useEffect } from 'react';
import './Slider.css';
import {Read} from '../Shared/Api';

const Slider = ({account, lang }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const [loaded, Load] = useState(false)
  const [items , Items] = useState([])

  useEffect(()=>{        
    if(account?.Service && !loaded) {
      Read(`/blog/${account.Service}`, Items, Load)
      //console.log(items)
    }
  },[account])


  useEffect(() => {
    let interval;
    if (isAutoPlaying) {
      interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % items.length);
      }, 9000);
    }
    return () => clearInterval(interval);
  }, [isAutoPlaying, items.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % items.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + items.length) % items.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="slider-container">
      <div 
        className="slider-track"
        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
      >
        {items.map((slide, index) => (
          <div key={index} className="slide">
            <img
              src={slide.Image}
              alt={slide.Title}
            />
            <div className="slide-content">
              <h2>{slide.Title}</h2>
              <p>{slide.Introduction}</p>
            </div>
          </div>
        ))}
      </div>

      <button
        onClick={prevSlide}
        className="nav-button prev-button"
        aria-label="Previous slide"
      >
        ‹
      </button>
      <button
        onClick={nextSlide}
        className="nav-button next-button"
        aria-label="Next slide"
      >
        ›
      </button>

      <div className="dots-container">
        {items.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`dot ${currentSlide === index ? 'active' : ''}`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>

      <button
        onClick={() => setIsAutoPlaying(!isAutoPlaying)}
        className="autoplay-button"
        aria-label={isAutoPlaying ? "Pause autoplay" : "Start autoplay"}
      >
        {isAutoPlaying ? "⏸" : "▶"}
      </button>
    </div>
  );
};

export default Slider;